import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>

      <footer className="footer-area" style={{marginTop:"-80px"}}>
        <div className="footer-shape">
          <img src="assets/img/shape/08.png" alt />
        </div>
        <div className="footer-widget">
          <div className="container">
            <div className="footer-widget-wrap pt-100 pb-80">
              <div className="row g-4">
                <div className="col-lg-3" style={{marginTop:"-40px"}}>
                  <div className="footer-widget-box about-us">
                    <Link to="/" className="footer-logo">
                      <img src="./assets/yog/Yogesh_logo.jpg" style={{ width: "130px", height: "130px", borderRadius: "100%" }} alt />
                    </Link>
                    <div className="col-md-6 align-self-center container">
                      <ul className="footer-social container">
                        <li><Link to="https://www.instagram.com/yogeshsolarenergy/?utm_source=ig_web_button_share_sheet" target="_blank"><i className="fab fa-instagram" /></Link></li>
                        <li><a to="#"><i className="fab fa-facebook-f" /></a></li>
                        <li><a to="#"><i className="fab fa-youtube" /></a></li>
                      </ul>
                    </div>
                    {/* <p className="mb-4">
                      At Yogesh Solar Energy, our vision is simple yet powerful — to create a sustainable future powered by clean and renewable energy.


                    </p> */}
                  </div>
                </div>
                <div className="col-6 col-lg-2" style={{marginTop:"-40px"}}>
                  <div className="footer-widget-box list">
                    <h4 className="footer-widget-title">Quick Links</h4>
                    <ul className="footer-list">
                      <li><Link to="/"><i className="far fa-angle-double-right" />Home</Link></li>
                      <li><Link to="/about"><i className="far fa-angle-double-right" />About Us</Link></li>
                      <li><Link to="/contact-us"><i className="far fa-angle-double-right" />Contact Us</Link></li>
                      <li><Link to="/gallery"><i className="far fa-angle-double-right" />Our Gallery</Link></li>
                      <li><Link to="/blog"><i className="far fa-angle-double-right" />Blog & Updates</Link></li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3" style={{marginTop:"-40px"}}>
                  <div className="footer-widget-box">
                    <h4 className="footer-widget-title">Contact Us</h4>
                    <ul className="footer-contact">
                      <li>
                        <div className="icon">
                          <i className="far fa-location-dot" />
                        </div>
                        <div className="content">
                          <h6>Our Address</h6>
                          <a href='https://share.google/o1YxzZaEEilhaVUb7' target="_blank">
                            <p>Ward No. 15, Hanuman Nagar Nai Basti, Raghuraj Nagar Satna, (M.P.) 485001</p>
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="far fa-phone" />
                        </div>
                        <div className="content">
                          <h6>Call Us</h6>
                          <a href="tel:+91 7024671002">+91 7024671002</a>
                          <a href="tel:+91 7240954834">+91 7240954834</a>
                        </div>
                      </li>
                      {/* <li>
                        <div className="icon">
                          <i className="far fa-envelope" />
                        </div>
                        <div className="content">
                          <h6>Mail Us</h6>
                          <a to="mailto:yogeshsolarenergy2026@gmail.com">yogeshsolarenergy2026@
                            gmail.com</a>
                        </div>
                      </li> */}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3" style={{marginTop:"-40px"}}>
                  <div className="footer-widget-box">
                    <h4 className="footer-widget-title">Google Maps</h4>
                    <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=400&height=250&hl=en&q=Yogesh Solar Energy ward no 15, Hanuman nagar nai basti, Satna, Madhya Pradesh 485005&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google map embed html</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:250px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:250px;}.gmap_iframe {height:250px!important;}" }} /></div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-12 align-self-center">
                <p className="copyright-text" style={{ textAlign: "center" }}>
                  2026 © Yogesh Solar Energy | <a href='tel:+91 8982471422'>Designed by Web solution & digital marketing</a>
                </p>
              </div>
              {/* <div className="col-md-6 align-self-center">
                <ul className="footer-social">
                  <li><a to="#"><i className="fab fa-facebook-f" /></a></li>
                  <li><a to="#"><i className="fab fa-x-twitter" /></a></li>
                  <li><a to="#"><i className="fab fa-linkedin-in" /></a></li>
                  <li><a to="#"><i className="fab fa-youtube" /></a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </footer>
      <a to="#" id="scroll-top" className="active"><i className="far fa-arrow-up" /></a>
      <PopUp />
      <WhatsappIcon />



    </>
  )
}

export default Footer